import React, { useState, useCallback, useMemo, useEffect } from 'react';
import './index.scss';
import { getIn18Text } from 'api';
import { Select, Button } from 'antd';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import TranslateModal from './translateModal';
import { translateLangMap, supportDetectLang, isSupportOriginLang } from './errCodeMsg';
import { TongyongJiantou1Xia, TongyongJiazai } from '@sirius/icons';
import { ReactComponent as JichuCuowutishiXian } from '@/images/icons/jichu_cuowutishi_xian.svg';
import { parseLangKey, isTranslateSuccess } from '@web-mail/util';
const antIcon = React.createElement(LoadingOutlined, { style: { fontSize: 24 }, spin: true });
const { Option, OptGroup } = Select;
const TranslateTips = ({ translateInfo, content, handleTranslateLang }) => {
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const [visible, setVisible] = useState(true);
    const [selectedToLang, setSelectedToLang] = useState('zh-CHS');
    const [selectedFromLang, setSelectedFromLang] = useState('zh-CHS');
    const [isZh, setIsZh] = useState(true);
    useEffect(() => {
        console.log('[TranslateTips changed By content]', content);
        if (content) {
            const { from, to } = getFromAndTo(content);
            setSelectedFromLang(from);
            setIsZh(from.includes('zh'));
            setSelectedToLang(to);
            setVisible(true);
        }
    }, [content]);
    const [visibleTransModel, setVisibleTransModel] = useState(false);
    const isLimit = useMemo(() => productVersionId !== 'sirius', [productVersionId]);
    const getFromAndTo = useCallback(content => {
        var _a, _b, _c;
        const defaultLang = navigator.language === 'zh-CN' ? 'zh-CHS' : navigator.language;
        let from = defaultLang;
        let to = defaultLang;
        const langType = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.langType;
        const originLang = (_c = (_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.langListMap) === null || _c === void 0 ? void 0 : _c.originLang;
        if (originLang) {
            from = isSupportOriginLang(originLang) ? originLang : '不支持的语言类型';
        }
        if (langType && langType !== 'origin') {
            const parseData = parseLangKey(langType);
            from = parseData.from || from;
            to = parseData.to || to;
        }
        return {
            from,
            to,
        };
    }, []);
    const cancelTranslate = useCallback(() => setVisible(false), []);
    const closeIconBtn = useMemo(() => React.createElement("div", { className: "translate-tips-close translate-tips-close-div", onClick: cancelTranslate }), []);
    const renderGroupEl = useMemo(() => {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "name" }, getIn18Text('YIXIAFUFEIHOU')),
            React.createElement(Button, { type: "primary", onClick: e => {
                    setVisibleTransModel(true);
                } }, getIn18Text('FUFEIKAITONG'))));
    }, []);
    const transSelectOptionsEL = useMemo(() => {
        const keys = Object.keys(translateLangMap);
        if (keys) {
            return keys.map((key, i) => {
                if (isLimit && i === 2) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(OptGroup, { label: renderGroupEl },
                            React.createElement(Option, { disabled: true, value: key }, translateLangMap[key]))));
                }
                return (React.createElement(Option, { disabled: isLimit && i > 2, value: key }, translateLangMap[key]));
            });
        }
        return React.createElement(React.Fragment, null);
    }, [isLimit]);
    const transLoadingEl = useMemo(() => {
        return (React.createElement("div", { className: "translate-tips", "data-test-id": "translate-tips-panel" },
            React.createElement(TongyongJiazai, { fontSize: "16", className: "translate-tips-loading", wrapClassName: "translate-tips-loading sirius-spin" }),
            React.createElement("div", { className: "translate-tips-content", "data-test-id": "translate-loading" },
                React.createElement("div", { className: "loading-name" }, getIn18Text('FANYIZHONG..')),
                closeIconBtn)));
    }, []);
    const preTransEl = useMemo(() => {
        return (React.createElement("div", { className: "translate-tips" },
            React.createElement("div", { className: "translate-tips-pre-wrap" },
                React.createElement(JichuCuowutishiXian, { wrapClassName: "translate-icon-wrap", className: "translate-tips-info-icon" }),
                React.createElement(Select, { value: selectedFromLang, dropdownClassName: "translate-lang-dropdown-style", options: supportDetectLang, bordered: false, suffixIcon: React.createElement(TongyongJiantou1Xia, { fontSize: 12, className: "translate-jiantou", wrapClassName: "translate-jiantou" }), onChange: fromLang => {
                        setSelectedFromLang(fromLang);
                    } }),
                React.createElement("span", { className: "translate-pre-text" }, getIn18Text('FANYIWEI')),
                React.createElement(Select, { value: selectedToLang, dropdownClassName: "translate-lang-dropdown-style", bordered: false, suffixIcon: React.createElement(TongyongJiantou1Xia, { fontSize: 12, className: "translate-jiantou", wrapClassName: "translate-jiantou" }), onChange: toLang => {
                        setSelectedToLang(toLang);
                    } }, transSelectOptionsEL),
                React.createElement("span", { className: "translate-pre-text2", "data-test-id": "read-mail-translate-button", onClick: () => {
                        handleTranslateLang(selectedToLang, selectedFromLang);
                    } }, getIn18Text('FANYIYOUJIAN')),
                React.createElement("div", { className: "icon-close" },
                    React.createElement("div", { className: "translate-tips-close translate-tips-close-div", onClick: cancelTranslate })))));
    }, [handleTranslateLang, transSelectOptionsEL, selectedToLang, selectedFromLang, supportDetectLang]);
    const transSuccessEl = useMemo(() => {
        return (React.createElement("div", { className: "translate-tips", "data-test-id": "translate-tips-panel" },
            React.createElement("div", { className: "translate-tips-icon translate-tips-success" }),
            React.createElement("div", { className: "translate-tips-content", "data-test-id": "translate-tips-content" },
                React.createElement("div", null,
                    React.createElement(Select, { value: selectedFromLang, dropdownClassName: "translate-lang-dropdown-style", options: supportDetectLang, bordered: false, suffixIcon: React.createElement(TongyongJiantou1Xia, { fontSize: 12, className: "translate-jiantou", wrapClassName: "translate-jiantou" }), onChange: fromLang => {
                            setSelectedFromLang(fromLang);
                            handleTranslateLang(selectedToLang, fromLang);
                        } }),
                    React.createElement("span", { className: "translate-pre-text" }, getIn18Text('YIFANYIWEI')),
                    React.createElement(Select, { value: selectedToLang, dropdownClassName: "translate-lang-dropdown-style", bordered: false, suffixIcon: React.createElement(TongyongJiantou1Xia, { fontSize: 12, className: "translate-jiantou", wrapClassName: "translate-jiantou" }), onChange: toLang => {
                            setSelectedToLang(toLang);
                            handleTranslateLang(toLang, selectedFromLang);
                        } }, transSelectOptionsEL),
                    React.createElement("span", { className: "translate-tips-close-text", onClick: () => {
                            handleTranslateLang('origin');
                        }, "data-test-id": "translate-tips-close-text" }, getIn18Text('QUXIAOFANYI'))),
                React.createElement("div", { style: { height: '32px', lineHeight: '32px', display: 'flex' } }, closeIconBtn))));
    }, [translateInfo, handleTranslateLang, transSelectOptionsEL, selectedFromLang]);
    const transFailEl = useMemo(() => {
        return (React.createElement("div", { className: "translate-tips", "data-test-id": "translate-tips-panel" },
            React.createElement("div", { className: "translate-tips-icon translate-tips-error", style: { marginRight: 8 } }),
            React.createElement("div", { className: "translate-tips-content", "data-test-id": "translate-fail" },
                React.createElement("div", null,
                    translateInfo.errorMessage,
                    React.createElement("span", { className: "translate-tips-close-text", onClick: () => {
                            handleTranslateLang(selectedToLang, selectedFromLang);
                        } }, getIn18Text('ZHONGXINFANYI'))),
                closeIconBtn)));
    }, [translateInfo.errorMessage, handleTranslateLang, selectedToLang, selectedFromLang]);
    const visibleSuccess = useMemo(() => isTranslateSuccess(content), [content]);
    const visiblePreTrans = useMemo(() => !visibleSuccess && !isZh, [visibleSuccess, isZh]);
    const translateStatus = translateInfo.status;
    if (!visible) {
        return null;
    }
    if (translateStatus === 'process') {
        return transLoadingEl;
    }
    if (translateStatus === 'error') {
        return transFailEl;
    }
    if (translateStatus === 'none') {
        return (React.createElement(React.Fragment, null,
            visibleSuccess && transSuccessEl,
            visiblePreTrans && preTransEl,
            visibleTransModel && (React.createElement(TranslateModal, { visible: visibleTransModel, closeModal: () => {
                    setVisibleTransModel(false);
                } }))));
    }
    return null;
};
export default TranslateTips;
